/*
getEligibilityCriteriaExpressionDefinition, getMiCoverageExpressionDefinition, getEscrowRequirementsExpressionDefinition,
getLlpaCapSchemaExpressionDefinition, getAdjustmentSchemaExpressionDefinition moved to ExpressionDefinitionApiPricing
*/
export class ExpressionDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanPipelinesExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/loan-pipelines');
  }

  async getLoanRoleAssignmentExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/loan-role-assignment');
  }

  async getChatAssignmentExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/chat-assignment');
  }

  async getAutomatedActionExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/automated-actions');
  }

  async getFormBundleExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/form-bundle');
  }

  async getLoanActionsExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/loan-actions');
  }

  async getCICFeeReasonExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/cic-fee-reason');
  }

  async getChecklistsExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/checklists');
  }

  async getChecklistsVisibilityDefinition() {
    return this.#http.get('/ExpressionDefinition/checklists-visibility');
  }

  async getRoleBasedSigningExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/role-based-signing');
  }

  async getHalcyonFormInclusionExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/halcyon-form-inclusion');
  }

  async getAppraisalSurchargeExpressionDefinition() {
    return this.#http.get('/ExpressionDefinition/appraisal-surcharge');
  }
}
